import { Manager, type ManagerOptions } from 'socket.io-client';

/**
 * socket.io Manager factory — mirrors reference `utils/socket.js`.
 *
 * The backend is configured with `transports: ['websocket'], allowUpgrades:
 * false`; long-polling handshakes are rejected with 400. We force websocket
 * so we never hit `/socket.io/?transport=polling`.
 */
export function createSocketManager(
  url: string,
  options: Partial<ManagerOptions> = {},
): Manager {
  return new Manager(url, {
    transports: ['websocket'],
    upgrade: false,
    ...options,
  });
}
